export const accountMovement = {
  accountMovementTransaction: "Transacción",
  accountMovementAmount: "Monto",
  accountMovementDeposit: "Depósitos",
  accountMovementTransfer: "Envios",
  accountMovementBet: "Apuestas",
  accountMovementWithdrawal: "Retiros",
  accountMovementBonus: "Bonos",
  movementsBtnBack: "Volver",
  accountMovementBetAll: "Todas",
  accountMovementBetWon: "Ganadas",
  accountMovementBetLost: "Perdidas",
  movementsDepositDesc: "Historial de depósitos realizados en tu cuenta",
  movementsTransferDesc: "Envíos y recepciones entre usuarios",
  movementsBetDesc: "Resumen de apuestas realizadas y resultados",
  movementsWithdrawalDesc: "Historial de retiros procesados",
  movementsBonusDesc: "Bonos y promociones recibidas",
  movementsTransferReceived: "Recibidas",
  movementsTransferSent: "Enviadas",
  movementsTotalBets: "Total Apostado",
  movementsTotalWins: "Total Ganado",
  movementsNetResult: "Resultado Neto",
  movementsLoadMore: "Cargar más",
  movementsEmptyTitle: "Sin movimientos",
  movementsEmptyDesc: "Aún no tienes movimientos en esta categoría",
  paginationItemsPerPage: "/ página",
  paginationJumpTo: "Ir a",
  paginationJumpToConfirm: "confirmar",
  paginationPage: "Página",
  paginationPrevPage: "Página anterior",
  paginationNextPage: "Página siguiente",
  paginationPrev5: "5 páginas anteriores",
  paginationNext5: "5 páginas siguientes",
  paginationPrevPageTooltip: "Página anterior",
  paginationNextPageTooltip: "Página siguiente",
  paginationOf: "de",
  paginationItems: "elementos",
};
